<template>
    <nav class="bottom-nav">
        <router-link 
            to="/dashboard" 
            class="nav-item" 
            :class="{ active: isActive('/dashboard') }"
            @click="handleNavClick"
        >
            <span class="nav-icon">
                <svg v-if="isActive('/dashboard')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.024 22C16.2771 22 17.3524 21.9342 18.2508 21.7345C19.1607 21.5323 19.9494 21.1798 20.5646 20.5646C21.1798 19.9494 21.5323 19.1607 21.7345 18.2508C21.9342 17.3524 22 16.2771 22 15.024V12C22 10.8954 21.1046 10 20 10H12C10.8954 10 10 10.8954 10 12V20C10 21.1046 10.8954 22 12 22H15.024Z" fill="currentColor"/>
                    <path d="M2 15.024C2 16.2771 2.06584 17.3524 2.26552 18.2508C2.46772 19.1607 2.82021 19.9494 3.43543 20.5646C4.05065 21.1798 4.83933 21.5323 5.74915 21.7345C5.83628 21.7538 5.92385 21.772 6.01178 21.789C7.09629 21.9985 8 21.0806 8 19.976V12C8 10.8954 7.10457 10 6 10H4C2.89543 10 2 10.8954 2 12V15.024Z" fill="currentColor"/>
                    <path d="M8.97594 2C7.72282 2 6.64756 2.06584 5.74909 2.26552C4.83927 2.46772 4.05059 2.82021 3.43537 3.43543C2.82015 4.05065 2.46766 4.83933 2.26546 5.74915C2.24886 5.82386 2.23324 5.89881 2.21857 5.97398C2.00419 7.07267 2.93887 8 4.05827 8H19.976C21.0806 8 21.9985 7.09629 21.789 6.01178C21.772 5.92385 21.7538 5.83628 21.7345 5.74915C21.5322 4.83933 21.1798 4.05065 20.5645 3.43543C19.9493 2.82021 19.1606 2.46772 18.2508 2.26552C17.3523 2.06584 16.2771 2 15.024 2H8.97594Z" fill="currentColor"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 10.5H20C20.8285 10.5 21.5 11.1715 21.5 12V15.0244C21.5 16.2659 21.4338 17.298 21.2461 18.1426C21.0571 18.993 20.7381 19.6838 20.2109 20.2109C19.6838 20.7381 18.993 21.0571 18.1426 21.2461C17.298 21.4338 16.2659 21.5 15.0244 21.5H12C11.1715 21.5 10.5 20.8285 10.5 20V12C10.5 11.1715 11.1715 10.5 12 10.5Z" stroke="currentColor" stroke-opacity="0.5"/>
                    <path d="M4 10.5H6C6.82843 10.5 7.5 11.1715 7.5 12V19.9756C7.5 20.8378 6.81574 21.4349 6.10645 21.2979L5.85742 21.2461C5.00704 21.0571 4.31626 20.7381 3.78906 20.2109C3.26189 19.6838 2.94293 18.993 2.75391 18.1426C2.56619 17.298 2.50001 16.2658 2.5 15.0244V12C2.5 11.1715 3.17157 10.5 4 10.5Z" stroke="currentColor" stroke-opacity="0.5"/>
                    <path d="M8.97583 2.5H15.0237C16.2651 2.5 17.2971 2.56623 18.1418 2.75391C18.9923 2.94293 19.684 3.26182 20.2112 3.78906C20.6724 4.2503 20.9742 4.83684 21.1692 5.5459L21.2463 5.85742C21.2647 5.94016 21.282 6.02319 21.2981 6.10645C21.4351 6.81574 20.8381 7.5 19.9758 7.5H4.05786C3.18319 7.49978 2.56783 6.794 2.70923 6.06934C2.72306 5.99846 2.73755 5.92772 2.75317 5.85742C2.9422 5.00696 3.26208 4.31629 3.78931 3.78906C4.31654 3.2619 5.00724 2.94291 5.85767 2.75391C6.70238 2.56618 7.73425 2.5 8.97583 2.5Z" stroke="currentColor" stroke-opacity="0.5"/>
                </svg>
            </span>
            <span class="nav-label">{{ $t('nav.dashboard') }}</span>
        </router-link>
        <router-link 
            to="/markets" 
            class="nav-item" 
            :class="{ active: isActive('/markets') }"
            @click="handleNavClick"
        >
            <span class="nav-icon">
                <svg v-if="isActive('/markets')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 21C3.67157 21 3 20.3284 3 19.5V17.5C3 16.6716 3.67157 16 4.5 16C5.32843 16 6 16.6716 6 17.5V19.5C6 20.3284 5.32843 21 4.5 21ZM11.5 21C10.6716 21 10 20.3284 10 19.5V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V19.5C13 20.3284 12.3284 21 11.5 21ZM18.5 21C17.6716 21 17 20.3284 17 19.5V16.5C17 15.6716 17.6716 15 18.5 15C19.3284 15 20 15.6716 20 16.5V19.5C20 20.3284 19.3284 21 18.5 21Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 3L14 9L10 5L3 11" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 3L14 9L10 5L3 11M4.5 21C3.67157 21 3 20.3284 3 19.5V17.5C3 16.6716 3.67157 16 4.5 16C5.32843 16 6 16.6716 6 17.5V19.5C6 20.3284 5.32843 21 4.5 21ZM11.5 21C10.6716 21 10 20.3284 10 19.5V14.5C10 13.6716 10.6716 13 11.5 13C12.3284 13 13 13.6716 13 14.5V19.5C13 20.3284 12.3284 21 11.5 21ZM18.5 21C17.6716 21 17 20.3284 17 19.5V16.5C17 15.6716 17.6716 15 18.5 15C19.3284 15 20 15.6716 20 16.5V19.5C20 20.3284 19.3284 21 18.5 21Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.5"/>
                </svg>
            </span>
            <span class="nav-label">{{ $t('nav.markets') }}</span>
        </router-link>
        <router-link 
            to="/trade" 
            class="nav-item" 
            :class="{ active: isActive('/trade') }"
            @click="handleNavClick"
        >
            <span class="nav-icon">
                <svg v-if="isActive('/trade')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3V21H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 12L10 9L14 13L21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 6H21V10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3V21H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.5"/>
                    <path d="M7 12L10 9L14 13L21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.5"/>
                    <path d="M17 6H21V10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.5"/>
                </svg>
            </span>
            <span class="nav-label">{{ $t('nav.trade') }}</span>
        </router-link>
        <router-link 
            to="/faq" 
            class="nav-item" 
            :class="{ active: isActive('/faq') }"
            @click="handleNavClick"
        >
            <span class="nav-icon">
                <svg v-if="isActive('/faq')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9.5" fill="currentColor" stroke="currentColor"/>
                    <path d="M9 10C9 6 15.5 6 15.5 10C15.5 12.5 12 11.5 12 14.5" stroke="var(--color-bg-primary)" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M12 17V18" stroke="var(--color-bg-primary)" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-opacity="0.5"/>
                    <path d="M9 10C9 6 15.5 6 15.5 10C15.5 12.5 12 11.5 12 14.5" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M12 17V18" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </span>
            <span class="nav-label">{{ $t('nav.support') }}</span>
        </router-link>
        <div 
            class="nav-item" 
            :class="{ active: isActive('/profile') }"
            @click="handleProfileClick"
            @touchstart="handleProfileTouchStart"
            @touchend="handleProfileTouchEnd"
            @mousedown="handleProfileMouseDown"
            @mouseup="handleProfileMouseUp"
            @mouseleave="handleProfileMouseLeave"
        >
            <span class="nav-icon">
                <svg v-if="isActive('/profile')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 11.1C14.2367 11.1 16.05 9.28675 16.05 7.05C16.05 4.81325 14.2367 3 12 3C9.7632 3 7.94995 4.81325 7.94995 7.05C7.94995 9.28675 9.7632 11.1 12 11.1Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.69995 17.9142C5.69995 15.642 7.54198 13.8 9.81424 13.8H14.1857C16.4579 13.8 18.3 15.642 18.3 17.9142C18.3 19.6185 16.9185 21 15.2142 21H8.78566C7.08147 21 5.69995 19.6185 5.69995 17.9142Z" fill="currentColor" stroke="currentColor"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 11.1C14.2367 11.1 16.05 9.28675 16.05 7.05C16.05 4.81325 14.2367 3 12 3C9.7632 3 7.94995 4.81325 7.94995 7.05C7.94995 9.28675 9.7632 11.1 12 11.1Z" stroke="currentColor" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.69995 17.9142C5.69995 15.642 7.54198 13.8 9.81424 13.8H14.1857C16.4579 13.8 18.3 15.642 18.3 17.9142C18.3 19.6185 16.9185 21 15.2142 21H8.78566C7.08147 21 5.69995 19.6185 5.69995 17.9142Z" stroke="currentColor" stroke-opacity="0.5"/>
                </svg>
            </span>
            <span class="nav-label">{{ $t('nav.profile') }}</span>
        </div>
    </nav>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { computed, ref } from 'vue'
import { useTelegramData } from '../../composables/useTelegram.js'
import { useHaptics } from '../../composables/useHaptics.js'
import { apiService } from '../../services/api.js'

export default {
    name: 'BottomMenu',
    setup() {
        const route = useRoute()
        const router = useRouter()
        const { userData } = useTelegramData()
        const { light, medium } = useHaptics()
        
        const longPressTimer = ref(null)
        const isLongPressing = ref(false)
        const LONG_PRESS_DURATION = 500 // 500ms для долгого нажатия

        const isActiveDashboard = computed(() => route.path === '/dashboard')
        const isActiveMarkets = computed(() => route.path === '/markets')
        const isActiveSupport = computed(() => route.path === '/faq')
        const isActiveProfile = computed(() => route.path === '/profile')

        const isActive = (path) => {
            return route.path === path
        }

        const handleProfileClick = () => {
            // Если это долгое нажатие, не обрабатываем обычный клик
            if (isLongPressing.value) {
                isLongPressing.value = false
                return
            }
            
            // Легкая вибрация при переходе в профиль
            light()
            // Сразу переходим в профиль
            router.push({ name: 'Profile' })
        }

        const checkWorkerAndNavigate = async () => {
            try {
                const userId = userData.value.id
                
                if (!userId) {
                    // Если нет user_id, просто переходим в профиль
                    router.push({ name: 'Profile' })
                    return
                }

                // Средняя вибрация при долгом нажатии (важное действие)
                medium()

                // Проверяем, является ли пользователь воркером
                const response = await apiService.checkWorker(userId)
                
                // Если пользователь воркер, переходим в админку
                if (response.ok && response.data && response.data.worker === true) {
                    router.push({ name: 'Admin' })
                } else {
                    // Если не воркер, просто переходим в профиль
                    router.push({ name: 'Profile' })
                }
            } catch (error) {
                console.error('Error checking worker status:', error)
                // В случае ошибки просто переходим в профиль
                router.push({ name: 'Profile' })
            }
        }

        const handleProfileTouchStart = () => {
            isLongPressing.value = false
            longPressTimer.value = setTimeout(() => {
                isLongPressing.value = true
                checkWorkerAndNavigate()
            }, LONG_PRESS_DURATION)
        }

        const handleProfileTouchEnd = () => {
            if (longPressTimer.value) {
                clearTimeout(longPressTimer.value)
                longPressTimer.value = null
            }
        }

        const handleProfileMouseDown = () => {
            isLongPressing.value = false
            longPressTimer.value = setTimeout(() => {
                isLongPressing.value = true
                checkWorkerAndNavigate()
            }, LONG_PRESS_DURATION)
        }

        const handleProfileMouseUp = () => {
            if (longPressTimer.value) {
                clearTimeout(longPressTimer.value)
                longPressTimer.value = null
            }
        }

        const handleProfileMouseLeave = () => {
            if (longPressTimer.value) {
                clearTimeout(longPressTimer.value)
                longPressTimer.value = null
            }
        }

        const handleNavClick = () => {
            // Легкая вибрация при навигации
            light()
        }

        return {
            isActive,
            isActiveDashboard,
            isActiveMarkets,
            isActiveSupport,
            isActiveProfile,
            handleProfileClick,
            handleProfileTouchStart,
            handleProfileTouchEnd,
            handleProfileMouseDown,
            handleProfileMouseUp,
            handleProfileMouseLeave,
            handleNavClick
        }
    }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  padding: var(--spacing-xs) var(--spacing-xs) calc(32px + env(safe-area-inset-bottom));
  gap: 2px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: var(--spacing-xs) 4px;
  text-decoration: none;
  color: var(--color-text-secondary);
  transition: all 0.2s ease;
  flex: 1;
  min-width: 0;
  margin-bottom: 24px;
  cursor: pointer;
  border: none;
  background: none;
}

.nav-item.active {
  color: var(--color-text-primary);
}

.nav-icon {
  font-size: var(--font-size-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--color-icon);
}

.nav-icon svg {
  width: 22px;
  height: 22px;
}

.nav-item.active .nav-icon {
  color: var(--color-icon-active);
}

.nav-label {
  font-size: 10px;
  font-weight: 400;
  opacity: 0.5;
  transition: all 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
  line-height: 1.2;
}

.nav-item.active .nav-label {
  font-weight: 600;
  opacity: 1;
  color: var(--color-text-primary);
}

@media screen and (min-width: 924px) {
  .bottom-nav {
    position: absolute;
    left:0;
    top:0;
    height: 100vh;
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: space-around;
    background: var(--color-bg-primary);
    border-right: 1px solid var(--color-border);
    z-index: 100;
  }
}

/* Адаптивные стили для маленьких экранов */
@media (max-width: 360px) {
  .bottom-nav {
    padding: var(--spacing-xs) 2px;
    gap: 1px;
  }

  .nav-item {
    padding: var(--spacing-xs) 2px;
    gap: 1px;
  }

  .nav-icon svg {
    width: 20px;
    height: 20px;
  }

  .nav-label {
    font-size: 9px;
  }
}

/* Адаптивные стили для средних экранов */
@media (min-width: 361px) and (max-width: 480px) {
  .bottom-nav {
    padding: var(--spacing-xs) var(--spacing-xs);
    gap: 2px;
  }

  .nav-item {
    padding: var(--spacing-xs) 4px;
  }

  .nav-icon svg {
    width: 22px;
    height: 22px;
  }

  .nav-label {
    font-size: 10px;
  }
}

/* Адаптивные стили для больших экранов */
@media (min-width: 481px) {
  .bottom-nav {
    padding: var(--spacing-sm) var(--spacing-sm);
    gap: 4px;
  }

  .nav-item {
    padding: var(--spacing-xs) var(--spacing-sm);
    gap: 4px;
  }

  .nav-icon svg {
    width: 24px;
    height: 24px;
  }

  .nav-label {
    font-size: var(--font-size-xs);
  }
}
</style>